import { render, staticRenderFns } from "./FancyModalContentNew.vue?vue&type=template&id=5fb2f780&scoped=true"
import script from "./FancyModalContentNew.vue?vue&type=script&lang=js"
export * from "./FancyModalContentNew.vue?vue&type=script&lang=js"
import style0 from "./FancyModalContentNew.vue?vue&type=style&index=0&id=5fb2f780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2f780",
  null
  
)

export default component.exports